import reduxKeys from "../../constants/reduxKeys";
import { formatListItems } from "../../utils";

// reducers.js
const initialState = {
  filters: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case reduxKeys.SET_INVENTORY_FILTERS:
      const transferTypes = (action.payload?.transferTypes || [])
        .filter(item => item?.is_show ?? item?.isShow ?? true)
        .map(item => ({
          ...item,
          id: item.id ?? item.transferTypeId ?? item.transfertypeid,
          name: item.name ?? item.transferType ?? item.transfertype,
          allowed_states: item.allowed_states ?? item.allowedStates ?? null,
          is_show: item.is_show ?? item.isShow ?? true,
        }));
      const inventoryStates = formatListItems(
        action.payload.inventoryStates,
        action.payload.inventoryStates?.[0]?.inventoryStateId != null ? "inventoryStateId" : "id",
        action.payload.inventoryStates?.[0]?.inventoryState != null ? "inventoryState" : "name"
      );
      const inventoryTypes = formatListItems(
        action.payload.inventoryTypes,
        action.payload.inventoryTypes?.[0]?.inventoryTypeId != null ? "inventoryTypeId" : "id",
        action.payload.inventoryTypes?.[0]?.inventoryType != null ? "inventoryType" : "name"
      );
      return { ...state, filters: { ...state.filters, ...action.payload, transferTypes, inventoryTypes, inventoryStates, allTransferType: action.payload?.transferTypes ?? {} } };
    case reduxKeys.SET_SUPPLIERS:
      const list = formatListItems(action.payload, "supplierId", "supplierName");
      return { ...state, filters: { ...state.filters, suppliers: list } };
    case reduxKeys.SET_WAREHOUSE:
      const wareHouseList = formatListItems(action.payload, "warehouseId", "warehouseName");
      return { ...state, filters: { ...state.filters, warehouse: wareHouseList } };
    case reduxKeys.SET_SOFTWARE_PROVIDER:
      const softwareProviders = formatListItems(action.payload, "providerId", "providerName");
      return { ...state, filters: { ...state.filters, softwareProviders } };
      case reduxKeys.SET_BILLING_COMPANIES:
        const billingCompanies = formatListItems(action.payload, "billingCompanyId", "companyName");
        return { ...state, filters: { ...state.filters, billingCompanies} };
    case reduxKeys.SET_COMPANY_REQUEST_TYPE:
      const requestTypes = formatListItems(action.payload, "requestTypeId", "requestType");
      return { ...state, filters: { ...state.filters, requestTypes } };
      case reduxKeys.SET_USERS_ROLES:
        const userRoles = formatListItems(action.payload, "role_id", "role_name");
        return { ...state, filters: { ...state.filters, userRoles } };
    default:
      return state;
  }
};

export default reducer;